goog.provide("shadow.js.shim.module$src$svg$artwork$map_svg$default");
shadow.js.shim.module$src$svg$artwork$map_svg$default = shadow.js.shim.module$src$svg$artwork$map_svg.default;
